
import React from 'react';
import { Checkbox, FormControlLabel, IconButton } from '@mui/material';
import CustomTooltip from '__common/components/CustomTooltip';
import { InfoOutlined } from '@mui/icons-material';

interface props {
  labelText: string;
  label: string;
  checked?: boolean;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  disabled?: boolean;
  [key: string]: any;
}

export default (props: props) => {
  const { labelText, label, ...otherProps } = props;
  const labelWithButton = (
    <span style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
      {label}
      <CustomTooltip title={labelText} placement="right" isHtml variant="config">
        <IconButton size="small" style={{ padding: '2px' }}>
          <InfoOutlined className="flyout-info-icon" />
        </IconButton>
      </CustomTooltip>
    </span>
  );
  
  return (
    <FormControlLabel
      control={<Checkbox {...otherProps} />}
      label={labelWithButton}
    />
  );
};

